import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getTransaction = async (id) => {
    const { data: transactionId, error: transactionError } = await supabase
        .from('transactions')
        .select('*')
        .eq('id', id)
        .single();

    if (transactionError) {
        throw new Error(`Error fetching transaction: ${transactionError.message}`);
    }


    return transactionId;
};


export default function useGetTransactionByIdAnyStatus(id) {
    return useQuery({
        queryKey: ['useGetTransactionByIdAnyStatus', id],
        queryFn: () => getTransaction(id),
        staleTime: 0,
        enabled: !!id
    })
}
